export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function withTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number,
  label: string,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      reject(new Error(`${label} timed out after ${timeoutMs}ms`));
    }, timeoutMs);
  });

  return Promise.race([promise, timeout]).finally(() => {
    if (timer) {
      clearTimeout(timer);
    }
  });
}

export function isLocalControlUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return (
      parsed.hostname === "127.0.0.1" ||
      parsed.hostname === "localhost" ||
      parsed.hostname === "::1"
    );
  } catch {
    return false;
  }
}

export function isRetryableLocalWorkerRestart(
  status: number,
  body: string,
  url: string,
): boolean {
  return (
    isLocalControlUrl(url) &&
    ((status === 503 && body.includes("Your worker restarted mid-request")) ||
      (status === 500 && body.includes("Network connection lost")))
  );
}

export function isRetryableRecordObjectsError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /worker restarted mid-request|econnreset|network|socket connection was closed unexpectedly|timed out|bad gateway|too many requests|gateway timeout|control plane api error \((?:429|500|502|503|504)\)|graphql api error \((?:429|500|502|503|504)\)|failed to record batch/i.test(
    message,
  );
}

export function isRetryableEffectRegistrationError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /timed out|websocket disconnected|websocket not connected|rpc timeout|rpc error: internal error; reference|worker restarted mid-request|network connection lost|bad gateway|gateway timeout|too many requests|(?:control plane|granular|graphql) api error \((?:429|500|502|503|504)\)/i.test(
    message,
  );
}

export function isRetryableSessionDataError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /network connection lost|worker restarted mid-request|econnreset|socket connection was closed unexpectedly|bad gateway|gateway timeout|service unavailable|session data api error \((?:429|500|502|503|504)\)/i.test(
    message,
  );
}
